import React, { FC } from 'react';

import { SwitchButtons } from 'src/shared/components';
import './Notification.styles.scss';

interface Props {
  title: string;
  toggle: boolean | undefined;
  disabled: boolean;
  onToggle: (value: boolean) => Promise<void>;
  message?: string;
  titleTag?: 'h5' | 'p';
}

export const Notification: FC<Props> = ({
  title,
  message,
  toggle = false,
  disabled,
  onToggle,
  titleTag: Header = 'p',
}) => {
  return (
    <div className="my-4 d-flex align-items-baseline flex-wrap">
      <div className="notification-header w-75">
        <Header className="mb-1 fw-500">{title}</Header>
        {message && <label className="text-muted d-block">{message}</label>}
      </div>
      <SwitchButtons className="mt-3 mt-lg-0" disabled={disabled} toggle={toggle} onToggle={onToggle} />
    </div>
  );
};
